import ExcelJS from 'exceljs';
import { downloadInvoiceExcel as downloadInvoiceExcelNew } from './excelDownloadInvoice';

export let downloadIndicatorRef = null;

export const setDownloadIndicatorRef = (ref) => {
    downloadIndicatorRef = ref;
};

export const downloadExcel = async (data, fileName) => {
    if (downloadIndicatorRef?.current) {
        downloadIndicatorRef.current.startDownload();
    }

    await new Promise(resolve => setTimeout(resolve, 100));

    try {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Sheet1');
        
        if (data && data.length > 0) {
            worksheet.addRows(data);
            
            if (data[0] && Array.isArray(data[0])) {
                const columnCount = data[0].length;
                worksheet.columns = Array(columnCount).fill().map(() => ({ width: 15 }));
                
                worksheet.getRow(1).font = { bold: true };
                worksheet.getRow(1).alignment = { horizontal: 'center', vertical: 'middle' };
            }
        }
        
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName;
        link.click();
        URL.revokeObjectURL(url);

        if (downloadIndicatorRef?.current) {
            downloadIndicatorRef.current.completeDownload();
        }
    } catch (error) {
        console.error('Excel download error:', error);
        if (downloadIndicatorRef?.current) {
            downloadIndicatorRef.current.completeDownload();
        }
        throw error;
    }
};

export const downloadExcelWithSheets = async (sheets, fileName) => {
    if (downloadIndicatorRef?.current) {
        downloadIndicatorRef.current.startDownload();
    }

    await new Promise(resolve => setTimeout(resolve, 100));

    try {
        const workbook = new ExcelJS.Workbook();
        
        sheets.forEach(({ data, name }) => {
            const worksheet = workbook.addWorksheet(name);
            
            if (data && data.length > 0) {
                worksheet.addRows(data);
                
                if (data[0] && Array.isArray(data[0])) {
                    const columnCount = data[0].length;
                    worksheet.columns = Array(columnCount).fill().map(() => ({ width: 15 }));
                    
                    worksheet.getRow(1).font = { bold: true };
                    worksheet.getRow(1).alignment = { horizontal: 'center', vertical: 'middle' };
                }
            }
        });
        
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName;
        link.click();
        URL.revokeObjectURL(url);

        if (downloadIndicatorRef?.current) {
            downloadIndicatorRef.current.completeDownload();
        }
    } catch (error) {
        console.error('Excel download error:', error);
        if (downloadIndicatorRef?.current) {
            downloadIndicatorRef.current.completeDownload();
        }
        throw error;
    }
};

export const downloadInvoiceExcel = async (invoiceData) => {
    return downloadInvoiceExcelNew(invoiceData, downloadIndicatorRef);
};